// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pl9K","content":"styles_content__JeXQJ"};